import { useState, useEffect } from 'react';
import { Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomButton from '../../MUI_custom_component/Button/CustomButton';
import CustomSnackbar from '../../MUI_custom_component/SnackBar/index';
import LocationPermissionSvg from '../../../v3/Illustrration/components/LocationPermissionSvg';
import { toast } from 'react-toastify';
import customToast from '../../../utils/customToast';

const LocationPermissionModal = ({ onTurnOnLocation, onCancel , showDeniedLocationMessage }) => {
    const isMobile = useMediaQuery('(max-width: 1200px)');
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    useEffect(() => {
      if (showDeniedLocationMessage){
        customToast.error("You have blocked HUMBEE from tracking your location. To use this, change your location settings in browser.")
      }
    }, [showDeniedLocationMessage]);
      
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
        pt: 2,
        px: 2,
        pb: 4,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomRightRadius: 16,
        borderBottomLeftRadius: 16,
        backgroundColor: 'white',
        width: '100%',
        height: isMobile?'100vh':'auto',
        backgroundColor:'white'
      }}
    >
      {/* Back button */}
      <IconButton
        onClick={onCancel}
        sx={{
          position: 'absolute',
          top: 16,
          left: 16,
          backgroundColor: 'white',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          '&:hover': { backgroundColor: '#f5f5f5' },
        }}
      >
        <ArrowBackIcon sx={{ fontSize: 24, color: '#333' }} />
      </IconButton>

      {/* Illustration */}
      <Box
        sx={{
          width: 200,
          height: 159,
          overflow: 'hidden',
          flexShrink: 0,
          pointerEvents: 'none',
        }}
      >
        <LocationPermissionSvg width={200} height={159} />
      </Box>

      {/* Text + Buttons */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, width: '100%' }}>
        {/* Text block */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            alignItems: 'center',
            textAlign: 'center',
            px: 2,
          }}
        >
          <Typography variant='h1'>Enable your location</Typography>
          <Typography variant='body1'>
            To proceed with the reward address capture enable location access in settings.
          </Typography>
        </Box>

        {/* Buttons block */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
          <CustomButton
            variant='filled'
            color='warning'
            label='Turn on Location'
            fullWidth
            onClick={onTurnOnLocation}
          />
          <CustomButton
            variant='text'
            color='warning'
            label='Cancel'
            fullWidth
            onClick={onCancel}
          />
        </Box>
      </Box>
   
    </Box>
  );
};

export default LocationPermissionModal;
